import { useCallback } from 'react'

import { Status, useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'
import { SuperEvent } from 'super-events/types'

const useCreateOrUpdateSuperEvent = (): [(payload: SuperEvent) => Promise<SuperEvent>, Status<SuperEvent>] => {
  const organization = useCurrentOrg()
  const [request, status] = useFetchRefactored<SuperEvent>()

  const createOrUpdateSuperEvent = useCallback(
    (payload: SuperEvent) => {
      return request({
        method: payload.id ? 'put' : 'post',
        url: `/organizations/${organization.id}/super_events${payload.id ? `/${payload.id}` : ''}`,
        config: {
          body: payload,
        },
      })
    },
    [organization.id, request],
  )

  return [createOrUpdateSuperEvent, status]
}

export default useCreateOrUpdateSuperEvent
